export default __webpack_public_path__ + "images/8a7c4f86d31245c746691b6d1b289ec2-school.webp";